/*
 * Prevents the 1990s terminal's pop-up ads (SATComponent.prototype.
 * spawnPopup90) from spawning the exact same ad twice while both copies
 * would be on screen at once. The base method picks uniformly at random
 * from the full ~20-entry deck (this._popupDeck) every time it fires, with
 * no check against what's already open, so e.g. two "CHAIN LETTER" pop-ups
 * could easily end up on screen side by side.
 *
 * A full replacement, not a wrap around the original — the bug is the
 * selection itself, so there's nothing left to preserve by calling through
 * to it. Picks only from deck entries whose title isn't already showing;
 * falls back to the full deck only in the (practically unreachable, since
 * at most 6 popups show at once against a ~20-entry deck) case where every
 * entry is already open.
 *
 * Also drops 9 entries from the deck outright, at the merchant's request:
 * SouthernAirTrade.geo, Guestbook, Shipping Advisory, Records Request,
 * Account Notice, MILLENNIUM SALE, PAGER ALERT, Y2K ADVISORY, and CHAIN
 * LETTER. this._popupDeck itself is a class-field instance property (set
 * in sat-app.js's constructor before this script ever runs), not something
 * a prototype patch can override — filtered here, at the one place that
 * already reads from it, instead.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }
  if (typeof window.SATComponent.prototype.spawnPopup90 !== 'function') { return; }

  var REMOVED_TITLES = [
    'SouthernAirTrade.geo', 'Guestbook', 'Shipping Advisory', 'Records Request',
    'Account Notice', 'MILLENNIUM SALE', 'PAGER ALERT', 'Y2K ADVISORY', 'CHAIN LETTER'
  ];

  window.SATComponent.prototype.spawnPopup90 = function () {
    var deck = (this._popupDeck || []).filter(function (d) { return REMOVED_TITLES.indexOf(d.title) === -1; });
    if (!deck.length) { return; }
    var openTitles = (this.state.popups || []).map(function (p) { return p.title; });
    var available = deck.filter(function (d) { return openTitles.indexOf(d.title) === -1; });
    var pool = available.length ? available : deck;
    var d = pool[Math.floor(Math.random() * pool.length)];
    var id = Date.now() + Math.random();
    var self = this;
    this.beep(660, 0.05, 'square', 0.04);
    setTimeout(function () { self.beep(880, 0.05, 'square', 0.035); }, 90);
    this.setState(function (st) {
      return {
        popups: [].concat(st.popups, [Object.assign({}, d, { id: id, jitter: Math.round(Math.random() * 4 - 2) })]).slice(-6)
      };
    });
  };
})();
